import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4" data-id="element-260">
      <div className="max-w-lg md:max-w-4xl mx-auto text-center" data-id="element-261">
        <div className="text-2xl font-black text-white mb-6" data-id="element-262">
          🥦 NUTRIPEQUES
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm" data-id="element-263">
          <button onClick={() => setModalContent('privacy')} className="hover:text-white transition-colors" data-id="element-264">
            Política de Privacidad
          </button>
          <button onClick={() => setModalContent('terms')} className="hover:text-white transition-colors" data-id="element-265">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-xs" data-id="element-266">
          © 2026 NutriPeques. Todos los derechos reservados.
        </p>
        <p className="text-xs mt-4 opacity-50 max-w-2xl mx-auto" data-id="element-267">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>

      {/* Modal */}
      {modalContent && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-268">
          <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden shadow-2xl" data-id="element-269">
            <div className="flex justify-between items-center p-4 border-b border-gray-100" data-id="element-270">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-271">
                {modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={() => setModalContent(null)} className="p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors" data-id="element-272">
                <X className="w-5 h-5" data-id="element-273" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-sm text-gray-600 space-y-4" data-id="element-274">
              {modalContent === 'privacy' ? <>
                  <p data-id="element-275">
                    <strong data-id="element-276">1. Recopilación de Información</strong>
                    <br data-id="element-277" />
                    Recopilamos información cuando te registras en nuestro
                    sitio, realizas una compra o te suscribes a nuestro boletín.
                    La información recopilada incluye tu nombre y correo
                    electrónico.
                  </p>
                  <p data-id="element-278">
                    <strong data-id="element-279">2. Uso de la Información</strong>
                    <br data-id="element-280" />
                    Cualquier información que recopilemos de ti puede ser
                    utilizada para: personalizar tu experiencia, mejorar nuestro
                    sitio web, mejorar el servicio al cliente y procesar
                    transacciones.
                  </p>
                  <p data-id="element-281">
                    <strong data-id="element-282">3. Privacidad del Comercio Electrónico</strong>
                    <br data-id="element-283" />
                    Somos los únicos propietarios de la información recopilada
                    en este sitio. Tu información personal no será vendida,
                    intercambiada, transferida o dada a ninguna otra empresa por
                    ningún motivo, sin tu consentimiento, excepto para el
                    propósito expreso de entregar el producto o servicio
                    adquirido.
                  </p>
                  <p data-id="element-284">
                    <strong data-id="element-285">4. Divulgación a Terceros</strong>
                    <br data-id="element-286" />
                    No vendemos, intercambiamos ni transferimos de ninguna otra
                    manera a terceros tu información de identificación personal.
                    Esto no incluye a terceros de confianza que nos asisten en
                    la operación de nuestro sitio web o en la realización de
                    nuestro negocio, siempre que esas partes acuerden mantener
                    esta información confidencial.
                  </p>
                  <p data-id="element-287">
                    <strong data-id="element-288">5. Uso de Cookies</strong>
                    <br data-id="element-289" />
                    Nuestras cookies mejoran el acceso a nuestro sitio e
                    identifican a los visitantes frecuentes. Además, nuestras
                    cookies mejoran la experiencia del usuario rastreando y
                    apuntando a sus intereses. Sin embargo, este uso de cookies
                    no está vinculado de ninguna manera a ninguna información de
                    identificación personal en nuestro sitio.
                  </p>
                  <p data-id="element-290">
                    <strong data-id="element-291">6. Consentimiento</strong>
                    <br data-id="element-292" />
                    Al utilizar nuestro sitio, aceptas nuestra política de
                    privacidad.
                  </p>
                </> : <>
                  <p data-id="element-293">
                    <strong data-id="element-294">1. Aceptación de los Términos</strong>
                    <br data-id="element-295" />
                    Al acceder y utilizar este producto digital (NutriPeques),
                    aceptas estar sujeto a estos Términos y Condiciones. Si no
                    estás de acuerdo con alguna parte de los términos, no podrás
                    acceder al producto.
                  </p>
                  <p data-id="element-296">
                    <strong data-id="element-297">2. Producto Digital</strong>
                    <br data-id="element-298" />
                    NutriPeques es un producto digital (eBook/Guía). El acceso
                    se proporciona inmediatamente después de la compra exitosa.
                    No se enviará ningún producto físico.
                  </p>
                  <p data-id="element-299">
                    <strong data-id="element-300">3. Política de Reembolso</strong>
                    <br data-id="element-301" />
                    Ofrecemos una garantía de devolución de dinero de 15 días.
                    Si no estás satisfecho con el producto, puedes solicitar un
                    reembolso completo dentro de los 15 días posteriores a la
                    compra. Pasados los 15 días, no se emitirán reembolsos bajo
                    ninguna circunstancia.
                  </p>
                  <p data-id="element-302">
                    <strong data-id="element-303">4. Propiedad Intelectual</strong>
                    <br data-id="element-304" />
                    Todo el contenido incluido en NutriPeques (textos, gráficos,
                    logotipos, imágenes, compilaciones de datos y software) es
                    propiedad de NutriPeques y está protegido por las leyes de
                    derechos de autor. No puedes reproducir, distribuir,
                    modificar, crear trabajos derivados, exhibir públicamente,
                    ejecutar públicamente, republicar, descargar, almacenar o
                    transmitir ninguno de los materiales de nuestro producto sin
                    el consentimiento previo por escrito.
                  </p>
                  <p data-id="element-305">
                    <strong data-id="element-306">5. Limitación de Responsabilidad</strong>
                    <br data-id="element-307" />
                    La información proporcionada en NutriPeques es solo para
                    fines educativos e informativos. No sustituye el consejo
                    médico profesional, diagnóstico o tratamiento. Siempre busca
                    el consejo de tu médico, pediatra u otro proveedor de salud
                    calificado con cualquier pregunta que puedas tener sobre una
                    condición médica o la alimentación de tu hijo.
                  </p>
                  <p data-id="element-308">
                    <strong data-id="element-309">6. Modificaciones</strong>
                    <br data-id="element-310" />
                    Nos reservamos el derecho de modificar o reemplazar estos
                    Términos en cualquier momento. Es tu responsabilidad revisar
                    estos Términos periódicamente para ver si hay cambios.
                  </p>
                </>}
            </div>
            <div className="p-4 border-t border-gray-100 bg-gray-50 text-right" data-id="element-311">
              <button onClick={() => setModalContent(null)} className="px-6 py-2 bg-gray-900 text-white rounded-xl font-bold hover:bg-gray-800 transition-colors" data-id="element-312">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </footer>;
}